// Lightweight logger that silences output in production builds.
// Errors still go to console.error so they show up in browser devtools / Sentry-style hooks.
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  log: (...args) => { if (!isProd) console.log(...args); },
  warn: (...args) => { if (!isProd) console.warn(...args); },
  error: (...args) => { console.error(...args); },
};
